import { Box, styled } from "@mui/material";

export const HeaderContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isCompact",
})<{ isCompact?: boolean }>(({ theme, isCompact = false }) => ({
  borderBottom: isCompact
    ? "none"
    : `1px solid ${theme.palette.border.secondary}`,
  boxShadow: isCompact ? theme.shadows[2] : "none",
  transition: "all 0.3s ease-in-out",
  margin: theme.spacing(0, isCompact ? -5 : 0, 1),
  padding: theme.spacing(0, isCompact ? 5 : 0, 3),
}));
